import styled from 'styled-components';
import spacing from '../../helpers/spacing';
import { Grid } from '../Grid';

export const GridWithMargins = styled(Grid)`
  && {
    margin-top: ${spacing(8)};
    margin-bottom: ${spacing(8)};
  }
`;
